// Unassigned Devices Management Functions
// Place this in /src/pages/DashboardPage.jsx before the component

/**
 * localStorage keys for unassigned devices
 * Pattern: unassigned_devices_[projectId]
 */
const getUnassignedDevicesStorageKey = (projectId) => `unassigned_devices_${projectId}`

/**
 * Get unassigned devices from localStorage
 */
const getUnassignedDevicesFromStorage = (projectId) => {
    try {
        const key = getUnassignedDevicesStorageKey(projectId)
        const stored = localStorage.getItem(key)
        return stored ? JSON.parse(stored) : []
    } catch (error) {
        console.error('[localStorage] Error reading unassigned devices:', error)
        return []
    }
}

/**
 * Save unassigned devices to localStorage
 */
const saveUnassignedDevicesToStorage = (projectId, devices) => {
    try {
        const key = getUnassignedDevicesStorageKey(projectId)
        localStorage.setItem(key, JSON.stringify(devices))
        console.log(`[localStorage] Saved ${devices.length} unassigned devices for project ${projectId}`)
    } catch (error) {
        console.error('[localStorage] Error saving unassigned devices:', error)
    }
}

/**
 * Create a new device (unassigned by default)
 * Returns the created device object
 */
const createUnassignedDevice = (deviceName) => {
    return {
        id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        name: deviceName,
        uid: `uid_${Date.now()}`,
        isLocal: true,  // Flag for local-only device
        createdAt: new Date().toISOString()
    }
}

/**
 * Extract unassigned devices from project data
 * (Devices that don't belong to any site - mimics Symfony's site IS NULL logic)
 */
const extractUnassignedDevices = (projectSites) => {
    const assignedDeviceIds = new Set()
    
    // Collect all devices that are assigned to sites
    projectSites.forEach(site => {
        if (site.devices && Array.isArray(site.devices)) {
            site.devices.forEach(device => {
                assignedDeviceIds.add(device.id)
            })
        }
    })
    
    // Note: This won't return devices that exist only on backend as unassigned
    // For that, we need to use localStorage to track local unassigned devices
    return assignedDeviceIds
}

export {
    getUnassignedDevicesStorageKey,
    getUnassignedDevicesFromStorage,
    saveUnassignedDevicesToStorage,
    createUnassignedDevice,
    extractUnassignedDevices
}
